export interface GetShelfTypeTempChangeCollectionsRequest {
  ids: number[]
}

export function GetShelfTypeTempChangeCollectionsRequestToJSON(
  value: GetShelfTypeTempChangeCollectionsRequest
): any {
  return {
    ids: value.ids.length > 0 ? value.ids : undefined
  }
}
